import React from 'react';
import { st, classes } from './emptyState.st.css';

export const EmptyStateIcon = () => (
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g>
            <g fill-rule="nonzero">
              <path
                fill="#28BF9A"
                d="M99.39 35L17.39 35 18.61 0 100.61 0z"
                transform="translate(-712 -365) translate(712 365) translate(2.5 19)"
              />
              <path
                fill="#C2E2FF"
                d="M113.39 81L31.39 81 32.61 46 114.61 46z"
                transform="translate(-712 -365) translate(712 365) translate(2.5 19)"
              />
              <path
                fill="#FFF"
                d="M52.9 52c3.023-.03 5.926 1.185 8.026 3.36 2.022 2.095 3.128 4.903 3.084 7.805L64 63.5c-.262 6.293-5.34 11.294-11.6 11.494l-.3.006c-3.023.03-5.926-1.185-8.026-3.36-2.022-2.095-3.128-4.903-3.084-7.805L41 63.5c.262-6.293 5.34-11.294 11.6-11.494l.3-.006zm-14-46c3.023-.03 5.926 1.185 8.026 3.36 2.022 2.095 3.128 4.903 3.084 7.805L50 17.5c-.262 6.293-5.34 11.294-11.6 11.494l-.3.006c-3.023.03-5.926-1.185-8.026-3.36-2.022-2.095-3.128-4.903-3.084-7.805L27 17.5c.262-6.293 5.34-11.294 11.6-11.494L38.9 6z"
                transform="translate(-712 -365) translate(712 365) translate(2.5 19)"
              />
              <path
                fill="#192C55"
                d="M53.17 57.58L57 69.1l-.9.32-1.39-4.13h-4.53l-1.69 4.16-.92-.38 4.67-11.49h.93zM89.86 67v1h-19v-1h19zM5.77 33.7l.74.67c-3.318 3.752-4.984 8.684-4.62 13.68.102 2.04.733 4.018 1.83 5.74.909 1.381 2.27 2.403 3.85 2.89.018-1.726.284-3.44.79-5.09.876-3.071 2.851-5.712 5.55-7.42 1.61-1 3.21-1.1 4.29-.34 1.004.88 1.49 2.21 1.29 3.53-.319 2.996-1.78 5.754-4.08 7.7-1.794 1.835-4.264 2.851-6.83 2.81.031.94.115 1.879.25 2.81.202 2.179 1.364 4.155 3.17 5.39 2.186 1.15 4.822 1.035 6.9-.3l.56.83c-1.306.84-2.828 1.28-4.38 1.27-1.276.008-2.53-.338-3.62-1-2.052-1.395-3.379-3.63-3.62-6.1-.146-1.031-.237-2.07-.27-3.11-1.923-.5-3.591-1.698-4.68-3.36-1.195-1.865-1.884-4.008-2-6.22-.365-5.253 1.393-10.434 4.88-14.38zm46.89 25.48l-2.08 5.11h3.79l-1.71-5.11zm49.48-.18v1h-31v-1h31zM14.42 45.06c-2.47 1.596-4.284 4.027-5.11 6.85-.48 1.61-.733 3.28-.75 4.96 2.67.24 5-1.49 6.18-2.55 2.101-1.767 3.447-4.272 3.76-7 .147-.97-.18-1.952-.88-2.64-1.1-.77-2.72.1-3.2.38zm24.249-21.99c.333.34.319.893-.032 1.238-.35.344-.905.35-1.238.01-.333-.338-.318-.892.032-1.237.35-.344.905-.35 1.238-.01zM75.86 21v1h-19v-1h19zM38.22 10.79c.98 0 1.919.397 2.6 1.103.68.705 1.045 1.657 1.01 2.637-.044 1.19-.63 2.295-1.59 3-1.008.737-1.626 1.892-1.68 3.14v.21h-1v-.25c.064-1.554.834-2.993 2.09-3.91.706-.513 1.14-1.319 1.18-2.19.026-.712-.237-1.405-.73-1.92-.492-.51-1.171-.796-1.88-.79-1.524.014-2.771 1.217-2.84 2.74V15h-1v-.5c.09-2.06 1.777-3.69 3.84-3.71zM88.14 13v1h-31v-1h31z"
                transform="translate(-712 -365) translate(712 365) translate(2.5 19)"
              />
            </g>
            <path
              d="M0 0H120V120H0z"
              transform="translate(-712 -365) translate(712 365)"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
);
